import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Button } from '@mui/material';
import Iconify from '../../../../components/iconify';
import { checkComponentPermission, isManager } from '../../../../utils/share';

const Header = ({ onCreateClick }) => {
  // Project creation is gated by the CREATE_PROJECT permission (admins).
  // Managers should also be able to create projects.
  const canCreateProject = checkComponentPermission('CREATE_PROJECT') || isManager();

  return (
    <Stack direction="row" alignItems="center" justifyContent="flex-end" mb={2.5}>
      {canCreateProject && (
        <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={onCreateClick}>
          New Project
        </Button>
      )}
    </Stack>
  );
};

Header.propTypes = {
  onCreateClick: PropTypes.func,
};

export default Header;
